import { colors } from '../styles'

interface StatusColor {
  primary: string
  secondary: string
}

interface Status {
  [index: string]: StatusColor
}

const colorSchemes: Status = {
  error: {
    primary: colors.appWatermelon,
    secondary: colors.appVeryLightPink,
  },
  info: {
    primary: colors.appClearBlue,
    secondary: colors.appPaleGrey,
  },
  warning: {
    primary: colors.appYellowOrange,
    secondary: colors.appOffWhite,
  },
  success: {
    primary: colors.appGreenishTeal,
    secondary: colors.appIce,
  },
}

const getPrimaryColor = (status = 'info') => colorSchemes[status].primary

const getSecondaryColor = (status = 'info') => colorSchemes[status].secondary

const Alert = {
  baseStyle: (props: any) => ({
    container: {
      background: 'none',
      px: 4,
      py: 3,
      minWidth: '400px',
      minHeight: '56px',
      padding: '8px 18px 8px 18px',
      borderRadius: '6px',
      border: 'solid 1px',
      borderColor: getPrimaryColor(props.status),
      backgroundColor: getSecondaryColor(props.status),
    },
    title: {
      // fontFamily: Poppins,
      fontSize: '14px',
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.71',
      letterSpacing: 'normal',
      textAlign: 'left',
      flexDirection: 'column',
      color: getPrimaryColor(props.status),
    },
    description: {
      // fontFamily: Poppins,
      fontSize: '14px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.71',
      letterSpacing: 'normal',
      textAlign: 'left',
      color: getPrimaryColor(props.status),
    },
    icon: {
      flexShrink: 0,
      marginEnd: 3,
      w: 25,
      h: 26,
      color: getPrimaryColor(props.status),
    },
    closeButton: {
      color: getPrimaryColor(props.status),
    },
  }),
  variants: {
    subtle: (props: any) => ({
      container: {
        borderColor: getPrimaryColor(props.status),
        backgroundColor: getSecondaryColor(props.status),
      },
      icon: {
        color: getPrimaryColor(props.status),
      },
      description: {
        color: getPrimaryColor(props.status),
      },
      title: {
        color: getPrimaryColor(props.status),
      },
    }),
    solid: (props: any) => ({
      container: {
        backgroundColor: getPrimaryColor(props.status),
      },
      icon: {
        color: colors.appPaleGrey,
      },
      description: {
        color: colors.appPaleGrey,
      },
      title: {
        color: colors.appPaleGrey,
      },
    }),
  },
}

export default Alert
